import { Box, Grid, IconButton, TextField, Typography } from '@mui/material';
import React from 'react';
import ClearSharpIcon from '@mui/icons-material/ClearSharp';
import { useDispatch } from 'react-redux';
import { DocumentData } from '../../../../services/apiTypes';
import { setDocumentComment } from '../../../../stores/confirmedInspection/slice';
import { useTranslation } from 'react-i18next';
import { MaxLength } from '../../../../_constants/maxLengthConst';

type DisplayImageProps = {
  files: [
    {
      id: number;
      fileName?: string;
      file?: File;
      isImage: boolean;
    },
    {
      id: number;
      fileName?: string;
      file?: File;
      isImage: boolean;
    },
    {
      id: number;
      fileName?: string;
      file?: File;
      isImage: boolean;
    },
    {
      id: number;
      fileName?: string;
      file?: File;
      isImage: boolean;
    },
  ];
  index: number;
  setFile: (index: number, file?: File) => void;
  documents: DocumentData[];
};

const DisplayImage: React.FC<DisplayImageProps> = ({
  files,
  index,
  setFile,
  documents,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid size={6}>
        {/* 削除ボタン */}
        <IconButton
          onClick={() => setFile(index, undefined)}
          className="hover-button2"
          sx={{
            position: 'absolute',
            right: '-15px',
            top: '-15px',
            bgcolor: '#FFF',
            display: 'none',
            width: '36px',
            height: '36px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <ClearSharpIcon />
        </IconButton>
      </Grid>
      {/* プレビュー画像 */}
      <Grid size={12} textAlign="center">
        {files !== undefined && (
          <Box
            component="img"
            id="preview"
            src={URL.createObjectURL(files[index].file!)}
            alt="preview"
            className="preview_img"
            style={{
              width: '90%',
              height: '250px',
              objectFit: 'contain',
            }}
            sx={{ pointerEvents: 'none' }}
          />
        )}
      </Grid>
      {/* ファイル名 */}
      <Grid size={12} textAlign="center">
        <Typography
          variant="caption"
          component="div"
          sx={{ color: 'grey.500' }}
        >
          {files[index].fileName}
        </Typography>
      </Grid>
      {/* コメント */}
      <Grid size={12} textAlign="center" style={{ padding: '0px 20px' }}>
        <TextField
          label={t('LBL_COMMENT')}
          size="small"
          fullWidth
          minRows={3}
          multiline
          sx={{
            bgcolor: 'background.paper',
            borderRadius: '6px',
            marginBottom: '1rem',
          }}
          slotProps={{
            htmlInput: {
              maxLength: MaxLength.ConfirmedInspection.FILE_UPLOAD_COMMENT,
            },
          }}
          defaultValue={
            documents.find((file) => file.id === files[index].id)?.comment ?? ''
          }
          onBlur={(event) =>
            dispatch(
              setDocumentComment({ id: index, comment: event.target.value }),
            )
          }
        />
      </Grid>
    </Grid>
  );
};

export default DisplayImage;
